<span *ngIf="!isEditing">{{field.value}}</span>
<input *ngIf="isEditing" type="text" [(ngModel)]="field.value" (change)="fieldUpdated.emit(field)" class="form-control" placeholder="Enter short text">
